import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 0,
    height: '100%'
  },
  content: {
    height: '100%'
  }
}));

const None = props => {
  const { children } = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <main className={classes.content}>{children}</main>
    </div>
  );
};

None.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default None;
